import clsx from "clsx"
import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { CopyIcon, ShareIcon } from "@/assets"
import { showToast } from "@/helpers/toast"
import styles from "./InviteLinkRow.module.scss"

interface IInviteLinkRowProps {
  link: string | undefined
  onShare: () => void
}

export const InviteLinkRow: FC<IInviteLinkRowProps> = ({ link, onShare }) => {
  const { t } = useTranslation()

  const handleCopy = () => {
    if (!link) return
    navigator.clipboard.writeText(link)
    showToast.info(t("message.copied", {}))
  }

  return (
    <div className={styles.InviteLinkRow}>
      <span className={styles.InviteLinkRow_label}>
        {t("friendLobby.shareLinkLabel")}
      </span>
      <div className={styles.InviteLinkRow_linkBox}>
        <span className={styles.InviteLinkRow_linkText}>{link}</span>
        <CopyIcon
          className={clsx(styles.InviteLinkRow_icon, styles.copy)}
          onClick={handleCopy}
        />
        <ShareIcon
          className={clsx(styles.InviteLinkRow_icon, styles.share)}
          onClick={onShare}
        />
      </div>
    </div>
  )
}
